export { default } from './CourseInfo';



// WEBPACK FOOTER //
// ./src/components/DataCentre/CourseInfo/index.ts